// Services
import localStorageService from '../services/localStorage/localStorage';

export const GRID_SIZE_LOCAL_STORAGE_KEY = 'milanote.gridSize';

export const getGridSizeLocalStorage = () => localStorageService.getItem(GRID_SIZE_LOCAL_STORAGE_KEY);
export const setGridSizeLocalStorage = (value) => localStorageService.setItem(GRID_SIZE_LOCAL_STORAGE_KEY, value);
